import cloneDeep from 'lodash-es/cloneDeep'
import form from '../imports/form'
import Route from './route'
import { createRouteSelectByQuote, processQuotePositions } from './index'
import { $api, $urlSystem } from '#imports'

// eslint-disable-next-line max-lines-per-function
export default () => {
  const { $searchObjects } = useNuxtApp()
  const store = $store()

  const loading = ref(false)

  const visible = ref(false)

  const updateNode = ref(true) // cập nhập lại thông tin node mới khi tính tối ưu và  lư

  const dataForm = ref({ ...form.initDataAddOrder })
  const dataFormByCustomerRequest = ref({ ...form.initDataAddOrderByCustomerRequest })
  const dataContact = ref<{ [key: string]: any }>({})
  const dataLogisticContact = ref<{ [key: string]: any }>({})
  const quoteData = ref<{ [key: string]: any } | null>(null)
  const shippingPlan = ref()
  const workflowPosition = ref()
  const customerRequestPages = ref(1)
  const viewShippingPlan = ref(false)
  const viewedShippingPlan = ref(false) // ít nhất 1 lần nhấn "Xem kế hoạch đơn hàng"
  const travelDetail = ref()

  const loadShippingPlan = ref(false)
  const numberWarehouseNode = ref(0) // số điểm Kho
  const numberWarehouseNodeHolidayWorking = ref(0) // số điểm Kho làm việc ngày lễ
  const numberWarehouseNodeOverTimeWorking = ref(0) // số điểm Kho làm việc ngoài giờ
  const solutionWaitingTimeTask = ref([])
  const showModalSolutionWaitingTimeTask = ref(false)
  const typeSolutionWaitingTimeTaskSelected = ref('')
  const typeSolutionWaitingTimeTaskSelectedTmp = ref('')
  const optimizeWaitingTime = ref()
  const manyPermanent = ref(false) // tại điểm có nhiều cố định
  const violatesPrinciples = ref(false) // vi phạm nguyên tắc vận chuyển
  const showViolatesPrinciples = ref(false)
  const conditionSetting = ref()
  const waitingTask = ref()
  const nodeData = ref([])
  const oldWorkingTimeRequest = ref([] as string[])
  const manualPlanning = ref({
    IN: null as string | null,
    OUT: null as string | null
  })
  const numberOfViolations = ref(0) // số lần đã vi phạm nguyên tắt vận chuyển liên tục

  // xác nhận chỉnh sửa kế hoạch đơn hàng
  const showConfirmEditShippingPlan = ref(false)

  // xử lý cảnh báo yêu cầu thời gian làm việc điểm Kho
  const contentWarningHolidayWorking = ref('')
  const contentWarningOverTimeWorking = ref('')
  const showWarningHolidayWorking = ref(false)
  const showWarningOverTimeWorking = ref(false)
  const actionCancelTimeWorking = ref(() => {})
  const actionConfirmTimeWorking = ref(() => {})

  // quote theo khách hàng
  const quoteLists = ref<{ [key: string]: any }>([])

  // edit travel time
  const CEditTravelTime = computed(() => {
    return !showConfirmEditShippingPlan.value && numberOfViolations.value === 2
  })

  const dataCooperatorBusinessOpportunity = ref<{ [key: string]: any }>({})

  const viewPosition = ref()

  const notResetFields = ref<boolean>(false)

  const changeRouteToOrder = ref<boolean>(false)

  const notFoundRoute = ref<boolean>(true)
  const showModalNotFoundRoute = ref<boolean>(false)
  const showModalConfirmSaveNotFoundRoute = ref<boolean>(false)
  const routeGGMap = ref<boolean>(false)
  const showWarningRouteGGMap = ref<boolean>(false)

  const disabledChangeBusinessOpportunity = ref<boolean>(true)

  const { handleFindRouteByQuote, handleFindRouteByQuoteRequestData, handleAddRouteToPositions, handleDeleteRouteToPositions } = Route()

  const CWarningRouteGGMap = computed(() => {
    if (!routeGGMap.value) {
      return ''
    }

    if (!CPositions.value || !CPositions.value.length) {
      return ''
    }

    // nodeLocationName
    const routeName = CPositions.value.map((item: any) => item.nodeLocationName).join(' >> ')
    return `Tuyến ${routeName} chưa được vẽ trên hệ thống. Vui lòng xác nhận nếu bạn muốn tiếp tục tính toán kế hoạch với thông tin từ Google Maps.
`
  })

  const CPositions = computed(() => {
    if (dataForm.value.createOrderFrom === 'QUOTE') {
      return cloneDeep(dataForm.value.positions)
    }

    return cloneDeep(dataFormByCustomerRequest.value.positions)
  })

  const CRoutingPositions = computed(() => {
    if (dataForm.value.createOrderFrom === 'QUOTE') {
      return cloneDeep(dataForm.value.routingPositions)
    }

    return cloneDeep(dataFormByCustomerRequest.value.routingPositions)
  })

  const CDisabledEditCompletionTime = computed(() => {
    if (typeSolutionWaitingTimeTaskSelected.value && typeSolutionWaitingTimeTaskSelected.value === 'solutionDefault') {
      return false
    }

    return viewShippingPlan.value || numberOfViolations.value > 0
  })

  const CPositionSolutionSelect = computed(() => {
    if (!typeSolutionWaitingTimeTaskSelectedTmp.value) {
      return null
    }

    const result = solutionWaitingTimeTask.value.filter((item: any) => item.key === typeSolutionWaitingTimeTaskSelectedTmp.value)?.[0] as any
    return result ? result.positions : null
  })

  const openWorkflowPosition = (position: any) => {
    if (workflowPosition.value) {
      workflowPosition.value.open(cloneDeep(position), cloneDeep(dataFormByCustomerRequest.value), true)
    }
  }

  const close = () => {
    resetFields(true)
    visible.value = false
  }

  const resetFields = (withoutCreateOrderFrom?: boolean) => {
    dataForm.value = {
      quote: null,
      idQuoteAndCharge: null,
      quoteName: null,
      customer: null,
      customerName: null,
      customerAbbreviationName: null,
      customerAddress: null,
      contact: null,
      contactName: null,
      logisticContact: null,
      logisticContactName: null,
      quoteCode: null,
      charge: null,
      chargeName: null,
      chargeData: {} as { [key: string]: string },
      workingTimeRequest: [],
      productivityOrder: null,
      transportation: null,
      positions: [],
      createOrderFrom: withoutCreateOrderFrom ? dataForm.value.createOrderFrom : 'QUOTE',
      condition: [],
      waitingTasks: [],
      businessOpportunity: null,
      businessOpportunityName: null,
      commodityName: null,
      commodity: null,
      request: null,
      notYetDistributionNumber: null,
      noBooking: null,
      routingPositions: null
    }

    dataFormByCustomerRequest.value = { ...form.initDataAddOrderByCustomerRequest }
    dataContact.value = {}
    dataLogisticContact.value = {}
    viewShippingPlan.value = false
    customerRequestPages.value = 1

    if (travelDetail.value) {
      travelDetail.value?.close()
    }

    if (shippingPlan.value) {
      shippingPlan.value.close()
    }

    typeSolutionWaitingTimeTaskSelected.value = ''
    typeSolutionWaitingTimeTaskSelectedTmp.value = ''
    manualPlanning.value = {
      IN: null,
      OUT: null
    }

    violatesPrinciples.value = false
    showViolatesPrinciples.value = false
    solutionWaitingTimeTask.value = []
    loadShippingPlan.value = false

    changeRouteToOrder.value = false

    resetNumberOfViolations()

    resetWarehouseNode()

    notFoundRoute.value = true
    showModalNotFoundRoute.value = false
    routeGGMap.value = false

    viewedShippingPlan.value = false
  }

  const resetWarehouseNode = () => {
    numberWarehouseNode.value = 0
    numberWarehouseNodeHolidayWorking.value = 0
    numberWarehouseNodeOverTimeWorking.value = 0
    dataForm.value.workingTimeRequest = []
    contentWarningHolidayWorking.value = ''
    contentWarningOverTimeWorking.value = ''
  }

  const resetNumberOfViolations = () => {
    numberOfViolations.value = 0
  }

  const getNodeData = async () => {
    const api = $urlSystem.node.getAll
    const data: any = await $api(api)
    const resData = data.data?.value
    if (resData?.success) {
      nodeData.value = resData.data
    } else {
      nodeData.value = []
    }
  }

  const quoteChange = async (val: { [key: string]: any }) => {
    resetWarehouseNode()
    resetNumberOfViolations()
    dataForm.value.workingTimeRequest = []
    dataForm.value.positions = []
    dataForm.value.commodity = ''
    dataForm.value.commodityName = ''

    if (!val || !Array.isArray(val) || !val.length || !val[0]) {
      quoteData.value = null
      dataForm.value.transportation = null
      dataForm.value.businessOpportunity = ''
      dataForm.value.businessOpportunityName = ''
      dataForm.value.quote = ''
      dataForm.value.charge = ''
      dataForm.value.chargeName = ''
      dataForm.value.routingPositions = null
      return
    }

    dataForm.value.charge = val[0].charge
    dataForm.value.chargeName = val[0].chargeName
    quoteData.value = val[0]
    dataForm.value.transportation = val[0].transportation
    dataForm.value.quote = val[0]._id
    dataForm.value.positions = val[0].positions
    dataForm.value.condition = []
    dataForm.value.businessOpportunity = val[0]?.businessOpportunity || ''
    dataForm.value.businessOpportunityName = val[0]?.businessOpportunityName || ''
    dataForm.value.routingPositions = val[0]?.routingPositions || null

    if (!dataForm.value.routingPositions || !dataForm.value.routingPositions?.route?.legs?.length || dataForm?.value?.routingPositions?.routeGGMap) {
      dataForm.value.routingPositions = null
    }

    handleCloseShippingPlan(true)
    resetWaitingTask()
    resetConditionSetting()

    notFoundRoute.value = true
    showModalNotFoundRoute.value = false
    routeGGMap.value = false
    viewedShippingPlan.value = false

    if (!dataForm.value.routingPositions || dataForm.value.routingPositions.routeGGMap) {
      const route = await findRoute()

      if (route && route.routingPositions?.route?.legs?.length) {
        dataForm.value.routingPositions = route.routingPositions

        if (route.routeGGMap) {
          routeGGMap.value = true
        }
      } else {
        notFoundRoute.value = true
      }
    } else {
      notFoundRoute.value = false
    }

    chargeChange(val)

    // add thời gian di chuyển từ routingPositions và positions
    dataForm.value.positions = handleAddRouteToPositions(dataForm.value.positions, dataForm.value.routingPositions)
  }

  const findRoute = async (options?: { [key: string]: any }) => {
    if (dataForm.value.createOrderFrom === 'QUOTE') {
      const route = await handleFindRouteByQuote({ quoteId: dataForm.value.quote, chargeId: dataForm.value.charge }, options)
      return route
    } else {
      const route = await handleFindRouteByQuoteRequestData(
        {
          ...dataFormByCustomerRequest.value,
          customer: dataForm.value.customer,
          customerName: dataForm.value.customerName,
          customerAbbreviationName: dataForm.value.customerAbbreviationName,
          contact: dataForm.value.contact,
          contactName: dataForm.value.contactName,
          createOrderFrom: dataForm.value.createOrderFrom,
          productivityOrder: dataForm.value.productivityOrder,
          condition: dataForm.value.condition || [],
          waitingTasks: dataForm.value.waitingTasks || [],
          workingTimeRequest: dataForm.value.workingTimeRequest
        },
        options
      )
      return route
    }
  }

  const chargeChange = (val: { [key: string]: any }) => {
    resetWarehouseNode()
    resetNumberOfViolations()

    if (!val || !Array.isArray(val) || !val.length) {
      dataForm.value.chargeData = {} as { [key: string]: string }
      dataForm.value.positions = []
      return
    }
    dataForm.value.chargeData = val[0]

    dataForm.value.positions.forEach((position: { [key: string]: any }, indexP: number) => {
      if (Array.isArray(position.tasks) && position.tasks.length) {
        position.tasks.forEach((task: { [key: string]: any }, indexT: number) => {
          if (Array.isArray(task.timeConditions) && task.timeConditions.length) {
            task.timeConditions.forEach((_timeCondition: { [key: string]: any }, indexTC: number) => {
              dataForm.value.positions[indexP].tasks[indexT].timeConditions[indexTC].time = ''
            })
          }
        })
      }
    })

    updateWarningTimeWorking(dataForm.value.positions)
    dataForm.value.condition = []
  }

  const updateWarningTimeWorking = (positions: any[]) => {
    positions.forEach((position: { [key: string]: any }) => {
      if (position.nodeTypeName === 'Kho') {
        numberWarehouseNode.value += 1

        const nodeValue = $searchObjects(nodeData.value, '_id', position.node, { limit: 1 })?.[0] || {}
        if (nodeValue.holidayWorking) {
          numberWarehouseNodeHolidayWorking.value += 1
        } else if (!contentWarningHolidayWorking.value) {
          contentWarningHolidayWorking.value = position.fullNameNode
        } else {
          contentWarningHolidayWorking.value = contentWarningHolidayWorking.value + ', ' + position.fullNameNode
        }

        if (nodeValue.workingOverTime) {
          numberWarehouseNodeOverTimeWorking.value += 1
        } else if (!contentWarningOverTimeWorking.value) {
          contentWarningOverTimeWorking.value = position.fullNameNode
        } else {
          contentWarningOverTimeWorking.value = contentWarningOverTimeWorking.value + ', ' + position.fullNameNode
        }
      }
    })

    contentWarningHolidayWorking.value = contentWarningHolidayWorking.value + ' không được cài đặt làm việc ngày lễ. Bạn có muốn tiếp tục?'
    contentWarningOverTimeWorking.value = contentWarningOverTimeWorking.value + ' không được cài đặt thời gian làm việc ngoài giờ. Bạn có muốn tiếp tục?'
  }

  watch(
    () => dataForm.value.workingTimeRequest,
    (val: string[]) => {
      actionCancelTimeWorking.value = () => {
        showWarningHolidayWorking.value = false
        showWarningOverTimeWorking.value = false
      }

      actionConfirmTimeWorking.value = () => {
        showWarningHolidayWorking.value = false
        showWarningOverTimeWorking.value = false
      }

      if (numberWarehouseNode.value !== numberWarehouseNodeHolidayWorking.value) {
        if (!oldWorkingTimeRequest.value.includes('holiday') && val.includes('holiday')) {
          showWarningHolidayWorking.value = true

          actionCancelTimeWorking.value = () => {
            dataForm.value.workingTimeRequest = val.filter((item: string) => item !== 'holiday')
            showWarningHolidayWorking.value = false
          }

          if (!numberWarehouseNodeHolidayWorking.value) {
            actionConfirmTimeWorking.value = () => {
              dataForm.value.workingTimeRequest = val.filter((item: string) => item !== 'holiday')
              showWarningHolidayWorking.value = false
            }
          }
        }
      }

      if (numberWarehouseNode.value !== numberWarehouseNodeOverTimeWorking.value) {
        if (!oldWorkingTimeRequest.value.includes('overTime') && val.includes('overTime')) {
          showWarningOverTimeWorking.value = true

          actionCancelTimeWorking.value = () => {
            dataForm.value.workingTimeRequest = val.filter((item: string) => item !== 'overTime')
            showWarningOverTimeWorking.value = false
          }

          if (!numberWarehouseNodeOverTimeWorking.value) {
            actionConfirmTimeWorking.value = () => {
              dataForm.value.workingTimeRequest = val.filter((item: string) => item !== 'overTime')
              showWarningOverTimeWorking.value = false
            }
          }
        }
      }

      oldWorkingTimeRequest.value = cloneDeep(val)
    },
    { deep: true }
  )

  watch(
    () => manualPlanning.value.IN,
    async () => {
      if (manualPlanning.value.IN) {
        await handleShowShippingPlan()
      }
    }
  )

  const handleShowShippingPlan = async (options?: { [key: string]: any }) => {
    loadShippingPlan.value = true
    showWarningRouteGGMap.value = false

    if (!viewShippingPlan.value) {
      viewedShippingPlan.value = true

      if (notFoundRoute.value) {
        const route = await findRoute()

        if (!route) {
          showModalNotFoundRoute.value = true
          loadShippingPlan.value = false
          return
        }

        const { routingPositions } = route

        if (dataForm.value.createOrderFrom === 'QUOTE') {
          dataForm.value.positions = handleAddRouteToPositions(dataForm.value.positions, routingPositions)
          dataForm.value.routingPositions = routingPositions
          notFoundRoute.value = false
        } else {
          dataFormByCustomerRequest.value.positions = handleAddRouteToPositions(dataFormByCustomerRequest.value.positions, routingPositions)
          dataFormByCustomerRequest.value.routingPositions = routingPositions
          notFoundRoute.value = false
        }
        if (route.routeGGMap) {
          routeGGMap.value = true
        } else {
          routeGGMap.value = false
        }
      }

      if (routeGGMap.value && !options?.confirmRouteGGMap && typeSolutionWaitingTimeTaskSelected.value !== 'manualPlanning' && numberOfViolations.value === 0) {
        showWarningRouteGGMap.value = true
        loadShippingPlan.value = false
        return
      }
    }

    if (typeSolutionWaitingTimeTaskSelected.value === 'manualPlanning') {
      if (!manualPlanning.value.IN) {
        process.client && $toast().error(`Vui lòng nhập thời gian cho vị trí IN của ${CPositions.value?.[0]?.nodeLocationName} (vị trí 1)`)
        loadShippingPlan.value = false
        return
      }

      if (typeof manualPlanning.value.IN !== 'number') {
        return
      }

      const data = await handleCalculateShippingPlanManual()

      if (travelDetail.value && data && !notFoundRoute.value) {
        travelDetail.value.show({ ...data, routingPositions: CRoutingPositions.value })
        viewShippingPlan.value = true
        viewedShippingPlan.value = true
      }

      loadShippingPlan.value = false

      return
    }

    // tính thông tin vận chuyển
    const shippingPlanData = await handleCalculateShippingPlan(options)

    if (shippingPlan.value && shippingPlanData && !notFoundRoute.value) {
      shippingPlan.value.show(CPositions.value, shippingPlanData)
    }

    loadShippingPlan.value = false
  }

  const handleEditShippingPlan = () => {
    showConfirmEditShippingPlan.value = true
  }

  const handleCloseShippingPlan = (clearSolution?: Boolean) => {
    if (shippingPlan.value) {
      closeWiewShippingPlan()
      viewShippingPlan.value = false
      showConfirmEditShippingPlan.value = false

      manualPlanning.value = {
        IN: null,
        OUT: null
      }
      if (clearSolution) {
        typeSolutionWaitingTimeTaskSelectedTmp.value = ''
        typeSolutionWaitingTimeTaskSelected.value = ''
      }
    }
  }

  const closeWiewShippingPlan = () => {
    if (travelDetail.value) {
      travelDetail.value?.close()
    }
    if (shippingPlan.value) {
      // deme xem kế hoạch tổng hợp
      shippingPlan.value.close()

      // end demo
    }
  }

  const openConditionSetting = () => {
    if (conditionSetting.value) {
      conditionSetting.value.open(dataForm.value.condition, CPositions.value)
    }
  }

  const updateConditionSetting = (val: { [key: string]: any }[]) => {
    dataForm.value.condition = val
  }

  const resetConditionSetting = () => {
    dataForm.value.condition = []
  }

  const openWaitingTask = () => {
    if (waitingTask.value) {
      waitingTask.value.open(dataForm.value.waitingTasks, CPositions.value)
    }
  }
  const updateWaitingTask = (val: { [key: string]: any }[]) => {
    dataForm.value.waitingTasks = val
  }

  const resetWaitingTask = () => {
    dataForm.value.waitingTasks = []
  }

  const selectContact = (item: { [key: string]: any }) => {
    dataContact.value = Array.isArray(item) && item.length && item[0]
  }

  const selectLogisticContact = (item: { [key: string]: any }) => {
    dataLogisticContact.value = Array.isArray(item) && item.length && item[0]
  }

  const selectCooperatorBusinessOpportunity = async (item: { [key: string]: any }) => {
    resetWarehouseNode()
    resetNumberOfViolations()
    handleCloseShippingPlan(true)
    resetWaitingTask()
    resetConditionSetting()
    dataCooperatorBusinessOpportunity.value = Array.isArray(item) && item.length && item[0]
    await setFormData()
    dataForm.value.condition = []
    notFoundRoute.value = true
    viewedShippingPlan.value = false
    const route = await findRoute()

    if (!route) {
      notFoundRoute.value = true
      showModalNotFoundRoute.value = false
      routeGGMap.value = false
    } else {
      const { routingPositions } = route

      dataFormByCustomerRequest.value.positions = handleAddRouteToPositions(dataFormByCustomerRequest.value.positions, routingPositions)
      dataFormByCustomerRequest.value.routingPositions = routingPositions

      notFoundRoute.value = false
      showModalNotFoundRoute.value = false
      if (route.routeGGMap) {
        routeGGMap.value = true
      } else {
        routeGGMap.value = false
      }
    }
  }

  const setFormData = async () => {
    dataFormByCustomerRequest.value.commodity = ''
    dataFormByCustomerRequest.value.commodityName = ''
    dataFormByCustomerRequest.value.productivity = dataCooperatorBusinessOpportunity.value.productivity || null
    dataFormByCustomerRequest.value.weightCommodity = dataCooperatorBusinessOpportunity.value.weightCommodity || null
    dataFormByCustomerRequest.value.transportation = dataCooperatorBusinessOpportunity.value.transportation || ''
    if (dataFormByCustomerRequest.value.transportation && dataFormByCustomerRequest.value.transportation === 'CONTAINER') {
      dataFormByCustomerRequest.value.contName = listLabelCont[dataCooperatorBusinessOpportunity.value.contCategory] ?? ''
    } else if (dataFormByCustomerRequest.value.transportation && dataFormByCustomerRequest.value.transportation === 'NON_CONTAINER') {
      dataFormByCustomerRequest.value.vehicleCategoryName = dataCooperatorBusinessOpportunity.value.vehicleCategoryDetail?.name ?? ''
    }
    dataFormByCustomerRequest.value.workflow = dataCooperatorBusinessOpportunity.value.workflow
    dataFormByCustomerRequest.value.workflowName = dataCooperatorBusinessOpportunity.value.workflowName
    dataFormByCustomerRequest.value.contCategory = dataCooperatorBusinessOpportunity.value.contCategory
    dataFormByCustomerRequest.value.vehicleCategory = dataCooperatorBusinessOpportunity.value.vehicleCategory
    dataFormByCustomerRequest.value.headContainer = false
    dataFormByCustomerRequest.value.mergeContainer = false
    dataFormByCustomerRequest.value.positions = dataCooperatorBusinessOpportunity.value.positions || []

    await setDataPosition()
  }

  const setDataPosition = async () => {
    try {
      const api = $urlClient.quote.quoteRequest.viewTimeComplete
      if (dataFormByCustomerRequest.value.businessOpportunity) {
        const data: any = await $api(api, { uriParams: { IDBUSINESSOPPORTUNITY: dataFormByCustomerRequest.value.businessOpportunity } })
        const resData = data?.data?.value
        if (resData && resData.success) {
          dataFormByCustomerRequest.value.positions = resData.data
          updateWarningTimeWorking(resData.data)
        }
      }
    } catch (e) {}
  }

  // tính thông tin vận chuyển đối với trường hợp lên kế hoạch thủ công (nhập In điểm đầu tiên)
  const handleCalculateShippingPlanManual = async () => {
    const api = $urlClient.order.order['calculate-shipping-plan-manual']
    const data: any = await $api(api, {
      body: {
        positions: dataForm.value.createOrderFrom === 'QUOTE' ? dataForm.value.positions : dataFormByCustomerRequest.value.positions,
        workingTimeRequest: dataForm.value.workingTimeRequest || [],
        updateNode: updateNode.value,
        waitingTasks: dataForm.value.waitingTasks || [],
        manualPlanning: manualPlanning.value
      }
    })
    const resData = data?.data?.value

    if (resData?.success) {
      const { positions, shippingPlan, optimalWaitingTime } = resData.data

      return resData.data
    }
  }

  const handleCalculateShippingPlan = async (options?: { [key: string]: any }) => {
    const api = $urlClient.order.order['calculate-shipping-plan']
    const data: any = await $api(api, {
      body: {
        positions: dataForm.value.createOrderFrom === 'QUOTE' ? dataForm.value.positions : dataFormByCustomerRequest.value.positions,
        workingTimeRequest: dataForm.value.workingTimeRequest || [],
        updateNode: !!updateNode.value,
        waitingTasks: dataForm.value.waitingTasks || []
      }
    })
    const resData = data?.data?.value
    if (resData?.success) {
      viewedShippingPlan.value = true

      const code = resData.data.code

      // tăng số lần vi phạm nguyên tắt
      if (code === 201) {
        if (!numberOfViolations.value || numberOfViolations.value === 1) {
          numberOfViolations.value++
          showModalSolutionWaitingTimeTask.value = true
          return resData.data
        } else {
          numberOfViolations.value++
          solutionWaitingTimeTask.value = resData.data.solutions
          showModalSolutionWaitingTimeTask.value = true
          typeSolutionWaitingTimeTaskSelected.value = ''
          typeSolutionWaitingTimeTaskSelectedTmp.value = ''
          return resData.data
        }
      }
      resetNumberOfViolations()

      // tối ưu thời gian chờ

      if (code === 200 && !notFoundRoute.value) {
        travelDetail.value?.show({
          ...resData.data,
          routingPositions: CRoutingPositions.value
        })
        viewShippingPlan.value = true

        return resData.data
      }

      // không thể tối ưu
      if (code === 202) {
        return resData.data
      }
    }
    return null
  }

  const confirmSolutionWaitingTimeTask = () => {
    if (numberOfViolations.value === 1) {
      numberOfViolations.value++
      showModalSolutionWaitingTimeTask.value = false
      return
    }

    if (!CPositionSolutionSelect.value) {
      return
    }
    if (dataForm.value.createOrderFrom === 'QUOTE') {
      dataForm.value.positions = CPositionSolutionSelect.value
    } else {
      dataFormByCustomerRequest.value.positions = CPositionSolutionSelect.value
    }

    typeSolutionWaitingTimeTaskSelected.value = cloneDeep(typeSolutionWaitingTimeTaskSelectedTmp.value)
    showModalSolutionWaitingTimeTask.value = false

    const solutionTypes = ['SM', 'MS']
    if (solutionTypes.includes(typeSolutionWaitingTimeTaskSelected.value)) {
      handleShowShippingPlan()
    } else {
      handleCloseShippingPlan()
    }
  }

  const resetViolations = () => {
    showModalSolutionWaitingTimeTask.value = false
    numberOfViolations.value = 0
  }

  const nextPage = async () => {
    if (customerRequestPages.value === 1) {
      const quoteByCustomerRequest = await handleGetQuoteByCustomerRequest()

      quoteByCustomerRequest.positions.forEach((position: { [key: string]: any }, indexP: number) => {
        // const travelTimeToNextPosition = Object.keys(legs).length ? legs[`${position._id}-${quoteByCustomerRequest?.positions?.[indexP + 1]?._id}`] : null
        // quoteByCustomerRequest.positions[indexP].travelTimeToNextPosition = travelTimeToNextPosition
        if (Array.isArray(position.tasks) && position.tasks.length) {
          position.tasks.forEach((task: { [key: string]: any }, indexT: number) => {
            if (Array.isArray(task.timeConditions) && task.timeConditions.length) {
              task.timeConditions.forEach((_timeCondition: { [key: string]: any }, indexTC: number) => {
                quoteByCustomerRequest.positions[indexP].tasks[indexT].timeConditions[indexTC].time = ''
                quoteByCustomerRequest.positions[indexP].travelTimeToNextPosition =
                  dataFormByCustomerRequest.value.positions?.[indexP]?.travelTimeToNextPosition
              })
            }
          })
        }
      })

      quoteByCustomerRequest.routingPositions = dataFormByCustomerRequest.value.routingPositions
      dataFormByCustomerRequest.value = quoteByCustomerRequest
      if (quoteByCustomerRequest.transportation && quoteByCustomerRequest.transportation === 'CONTAINER') {
        dataFormByCustomerRequest.value.contName = listLabelCont[quoteByCustomerRequest.contCategory] ?? ''
      }

      customerRequestPages.value = customerRequestPages.value + 1 || 1
      // }
    }
  }

  const handleGetQuoteByCustomerRequest = async () => {
    const api = $urlClient.order.order['quote-by-customer-request']
    const data: any = await $api(api, {
      body: {
        ...dataFormByCustomerRequest.value,
        customer: dataForm.value.customer,
        customerName: dataForm.value.customerName,
        customerAbbreviationName: dataForm.value.customerAbbreviationName,
        contact: dataForm.value.contact,
        contactName: dataForm.value.contactName,
        createOrderFrom: dataForm.value.createOrderFrom,
        productivityOrder: dataForm.value.productivityOrder,
        condition: dataForm.value.condition || [],
        waitingTasks: dataForm.value.waitingTasks || [],
        workingTimeRequest: dataForm.value.workingTimeRequest
      }
    })
    const resData = data?.data?.value
    if (resData?.success) {
      return resData.data
    }
    return null
  }

  const CConfigCont: { [key: string]: any } = computed(() => store.globalSettings.getGlobalSettings.configCont)
  const CConfigVehicle: { [key: string]: any } = computed(() => {
    return store.data.getVehicleCategories
  })

  const openWithMap = () => {
    viewPosition.value && viewPosition.value.open({ positions: cloneDeep(CPositions.value) })
  }

  const closeSolutionWaitingTimeTask = () => {
    showModalSolutionWaitingTimeTask.value = false
    typeSolutionWaitingTimeTaskSelected.value = ''
    // handleCloseShippingPlan()
  }

  const updatePosition = (data: { [key: string]: any }) => {
    if (data && typeof data === 'object' && dataForm.value.positions) {
      const findIndexPosition = dataForm.value.positions.findIndex((item: { [key: string]: any }) => {
        return item.index === data.index
      })
      if (findIndexPosition !== -1 && dataForm.value.positions) {
        dataForm.value.positions[findIndexPosition] = data
      }
    }
  }

  const customerChange = async (val: any) => {
    if (!val || !val?.[0] || !val?.[0]?._id) {
      return
    }

    dataFormByCustomerRequest.value = { ...form.initDataAddOrderByCustomerRequest }
    dataForm.value.customer = val[0]?._id || ''
    dataForm.value.customerName = val[0]?.name || ''
    dataForm.value.customerAbbreviationName = val[0]?.abbreviationName || val[0]?.name || ''
    dataForm.value.customerAddress = val[0]?.address || ''

    dataForm.value.contact = val[0]?.latestBusinessContact?._id || ''
    dataForm.value.contactName = val[0]?.latestBusinessContact?.fullName || ''
    dataContact.value = {
      email: val[0]?.latestBusinessContact?.email || '',
      phone: val[0]?.latestBusinessContact?.phone || ''
    }

    dataForm.value.logisticContact = val[0]?.latestLogisticContact?._id || ''
    dataForm.value.logisticContactName = val[0]?.latestLogisticContact?.fullName || ''
    dataLogisticContact.value = {
      email: val[0]?.latestLogisticContact?.email || '',
      phone: val[0]?.latestLogisticContact?.phone || ''
    }

    dataForm.value.condition = []
    dataForm.value.quote = ''
    dataForm.value.idQuoteAndCharge = ''
    dataForm.value.quoteName = ''

    dataForm.value.commodity = ''
    dataForm.value.commodityName = ''

    if (dataForm.value.customer && dataForm.value.createOrderFrom === 'QUOTE') {
      quoteLists.value = []
      quoteLists.value = await createRouteSelectByQuote(dataForm.value.customer)
    }

    resetWarehouseNode()
    resetNumberOfViolations()
    handleCloseShippingPlan(true)
    resetWaitingTask()
    resetConditionSetting()

    notFoundRoute.value = false
    showModalNotFoundRoute.value = false
    showModalConfirmSaveNotFoundRoute.value = false
  }

  const changeCustomerRequestPages = (page: number) => {
    customerRequestPages.value = page
  }

  // default value when create from quo page
  const setQuoteData = async (quoteData: { [key: string]: any }) => {
    resetFields()
    let customer = null as any
    if (quoteData.customer) {
      customer = await getCusomer(quoteData.customer)
    }

    dataForm.value.customer = quoteData.customer
    dataForm.value.customerName = quoteData.customerName
    dataForm.value.customerAbbreviationName = customer.abbreviationName
    dataForm.value.customerAddress = quoteData.customerAddress

    if (customer) {
      dataForm.value.contact = customer.latestBusinessContact?._id || ''
      dataForm.value.contactName = customer.latestBusinessContact?.fullName || ''
      dataContact.value.email = customer.latestBusinessContact?.email || ''
      dataContact.value.phone = customer.latestBusinessContact?.phone || ''

      dataForm.value.logisticContact = customer.latestLogisticContact?._id || ''
      dataForm.value.logisticContactName = customer.latestLogisticContact?.fullName || ''
      dataLogisticContact.value.email = customer.latestLogisticContact?.email || ''
      dataLogisticContact.value.phone = customer.latestLogisticContact?.phone || ''
    }

    quoteLists.value = processQuotePositions(quoteData)

    dataForm.value.idQuoteAndCharge = quoteLists.value[0]?.idQuoteAndCharge
    dataForm.value.quoteName = quoteLists.value[0]?.quoteAndRouteName

    await quoteChange([quoteLists.value[0]])

    dataForm.value.commodity = quoteLists.value[0]?.commodity
    dataForm.value.commodityName = quoteLists.value[0]?.commodityName

    changeRouteToOrder.value = true
  }

  const getCusomer = async (customerId: string) => {
    const api = $urlClient.partner['get-detail']

    const data: any = await $api(api, { uriParams: { ID: customerId } })

    const resData = data?.data?.value

    if (resData?.success) {
      return resData.data
    }

    return null
  }

  const handleAdjustShippingInformation = () => {
    showModalSolutionWaitingTimeTask.value = true
    showViolatesPrinciples.value = false
  }

  const quickShowModalSolutionWaitingTimeTask = () => {
    showModalSolutionWaitingTimeTask.value = true
    numberOfViolations.value = 3
  }

  const listLabelCont: { [key: number]: any } = {
    10: $t('labels.vehicleModule.10ft'),
    20: $t('labels.vehicleModule.20ft'),
    40: $t('labels.vehicleModule.40ft'),
    45: $t('labels.vehicleModule.45ft'),
    50: $t('labels.vehicleModule.other')
  }

  const handleUpdateRoute = async (route: any) => {
    if (!route) {
      return
    }
    notFoundRoute.value = false
    routeGGMap.value = false
    handleCloseShippingPlan()

    if (dataForm.value.createOrderFrom === 'QUOTE') {
      dataForm.value.positions = handleAddRouteToPositions(dataForm.value.positions, route.routingPositions)
      dataForm.value.routingPositions = route.routingPositions
    } else {
      dataFormByCustomerRequest.value.positions = handleAddRouteToPositions(dataFormByCustomerRequest.value.positions, route.routingPositions)
      dataFormByCustomerRequest.value.routingPositions = route.routingPositions
    }

    await handleShowShippingPlan()
  }

  const handleRejectRouteGGMap = () => {
    showWarningRouteGGMap.value = false
    routeGGMap.value = false
    notFoundRoute.value = true
    if (dataForm.value.createOrderFrom === 'QUOTE') {
      dataForm.value.routingPositions = null
      dataForm.value.positions = handleDeleteRouteToPositions(dataForm.value.positions)
    } else {
      dataFormByCustomerRequest.value.routingPositions = null
      dataFormByCustomerRequest.value.positions = handleDeleteRouteToPositions(dataFormByCustomerRequest.value.positions)
    }
  }

  return {
    visible,
    updateNode,
    dataAdd: dataForm,
    dataAddByCustomerRequest: dataFormByCustomerRequest,
    viewShippingPlan,
    dataContact,
    dataLogisticContact,
    shippingPlan,
    travelDetail,
    workflowPosition,
    customerRequestPages,
    loadShippingPlan,
    numberWarehouseNode,
    solutionWaitingTimeTask,
    showModalSolutionWaitingTimeTask,
    typeSolutionWaitingTimeTaskSelected,
    typeSolutionWaitingTimeTaskSelectedTmp,
    optimizeWaitingTime,
    manyPermanent,
    violatesPrinciples,
    showViolatesPrinciples,
    conditionSetting,
    waitingTask,
    manualPlanning,
    numberOfViolations,
    showConfirmEditShippingPlan,
    contentWarningHolidayWorking,
    contentWarningOverTimeWorking,
    showWarningHolidayWorking,
    showWarningOverTimeWorking,
    actionCancelTimeWorking,
    actionConfirmTimeWorking,
    quoteLists,
    CEditTravelTime,
    CPositions,
    CDisabledEditCompletionTime,
    openWorkflowPosition,
    close,
    resetFields,
    resetWarehouseNode,
    resetNumberOfViolations,
    getNodeData,
    quoteChange,
    handleShowShippingPlan,
    handleEditShippingPlan,
    handleCloseShippingPlan,
    openConditionSetting,
    updateConditionSetting,
    openWaitingTask,
    updateWaitingTask,
    selectContact,
    selectLogisticContact,
    selectCooperatorBusinessOpportunity,
    confirmSolutionWaitingTimeTask,
    resetViolations,
    nextPage,
    CConfigCont,
    CConfigVehicle,
    viewPosition,
    openWithMap,
    closeSolutionWaitingTimeTask,
    updatePosition,
    customerChange,
    changeCustomerRequestPages,
    setQuoteData,
    notResetFields,
    handleGetQuoteByCustomerRequest,
    listLabelCont,
    updateWarningTimeWorking,
    handleAdjustShippingInformation,
    quickShowModalSolutionWaitingTimeTask,
    changeRouteToOrder,
    loading,
    notFoundRoute,
    showModalNotFoundRoute,
    showModalConfirmSaveNotFoundRoute,
    CWarningRouteGGMap,
    showWarningRouteGGMap,
    findRoute,
    handleUpdateRoute,
    handleRejectRouteGGMap,
    routeGGMap,
    viewedShippingPlan,
    disabledChangeBusinessOpportunity
  }
}
